<template>
    <div class="confirm">
        <div @click="onClick" class="confirm__cross"></div>
        <div class="confirm__content">
          <p class="e-h2 u-color-pink">Votre séléction:</p>
          <div>
            <serie-card class="confirm__card" :title="serie.name" :producer="serie.provider" :image="`${cdnUrl}/${serie.image}`"></serie-card>
        <vote-button @click="onValidate" class="e-h4-canal confirm__button">
          <span>Confirmer mon vote</span>
        </vote-button>
          </div>
        </div>
    </div>
</template>

<script>
import SerieCard from './serie-card';
import VoteButton from '../Elements/vote-button';

export default {
  data() {
    return {
      cdnUrl: process.env.VUE_APP_CDN_BASE_URL,
    };
  },
  components: {
    SerieCard,
    VoteButton,
  },
  props: {
    serie: {
      required: true,
    },
  },
  methods: {
    onClick() {
      this.$emit('close');
    },
    onValidate() {
      this.$emit('validate');
    },
  },
};
</script>

<style lang="scss">
.confirm {
    background: var(--color-white-alpha);
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 10;
    padding: 74px 54px 0 54px;

    @include media('>=m') {
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__content {
      max-width: 333px;
      margin: auto;
      width: 100%;

      > div { position: relative; }
    }

    p {
        margin-bottom: 20px;
    }

    &__card {
        margin-bottom: 30px;
    }

    &__cross {
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: calc(54px - 13.5px);
        height: 30px;
        width: 30px;

        &::before, &::after {
            top: 50%;
            content: '';
            position: absolute;
            height: 5px;
            width: 100%;
            background: var(--color-pink);
        }

        &::after {
            transform-origin: center;
            transform: translateY(-50%) rotate(-45deg);
        }

        &::before {
            transform: translateY(-50%) rotate(45deg);
            transform-origin: center;
        }
    }
  &__button {
    // margin-top: var(--spacing-l);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-transform: uppercase;

    > span {
      display: flex;
      align-items: center;
      background-color: var(--color-pink);
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }

    @media (hover: hover) {
      &:hover:not(:disabled) {
        color: var(--color-black);
        > span {
          background-color: var(--color-white);
        }
      }
    }
  }
}
</style>
